import {
  HDialog,
  HTable,
  HLink,
  HSimpleTable,
} from './index'

function install(Vue) {
  Vue.component('h-dialog', HDialog);
  Vue.component('h-table', HTable);
  Vue.component('h-simple-table', HSimpleTable);
  Vue.component('h-link', HLink);
}

export default install